import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const InviteUserRequestDtoSchema = z.object({
  email: z.email(),
  fullName: z.string(),
  roleId: z.number(),
  facilityIds: z.array(z.number()).optional(),
  isDemoUser: z.boolean().optional(),
  sendInvite: z.boolean().optional(),
});

const InviteUserResponseDtoSchema = UserDtoSchema;

export type InviteUserRequestDto = z.infer<typeof InviteUserRequestDtoSchema>;
export type InviteUserResponseDto = z.infer<typeof InviteUserResponseDtoSchema>;

export const inviteUser = (
  dto: InviteUserRequestDto,
  config?: AxiosRequestConfig<InviteUserRequestDto>
) => {
  const data = InviteUserRequestDtoSchema.parse(dto);
  return api
    .post('/users/invite', data, config)
    .then(responseContract(InviteUserResponseDtoSchema));
};
